const urls = {
  TTOO: '/reservations/TTOO',
  Groups: '/reservations/groups'
};

export default urls;
